export default function TemplateMethodPage() {
  return (
    <ul>
      <li>Template Method: </li>
    </ul>
  );
}
